export default "__VITE_ASSET__CbuVru0x__"